// modules/StoreLocator/filters.ts

/**
 * Retrieves the selected options from a <select multiple>
 */
export function getSelectedOptions(selectEl: HTMLSelectElement | null): string[] {
    if (!selectEl) return [];
    return Array.from(selectEl.selectedOptions).map((o) => o.value).filter(Boolean);
}

/**
 * Visible filters
 */
export function visibleFilters() {
    const filters = document.querySelector(".store-locator__filters") as HTMLElement;
    const filtersBtn = filters?.querySelector(".form-filters-mobile") as HTMLElement;
    const selects = filters?.querySelector(".form-selects") as HTMLElement;

    if (!filters || !filtersBtn || !selects) return;

    filtersBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        selects.classList.toggle("visible");
    });

    document.addEventListener("click", (event) => {
        if (!filters.contains(event.target as Node)) {
            selects.classList.remove("visible");
        }
    });
}


